import React from 'react';
import { Route, Redirect } from "react-router-dom";
import { User } from 'firebase';

interface PrivateRouteProps {
  user: User|null;
  path: string; 
  children: any; 
  rest?: any;
}

const PrivateRoute = ({user, path, children, ...rest}: PrivateRouteProps) => {
  return (
    <Route
      {...rest}
      path={path}
      render={({location}) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
